<template>
  <div class="service-note">
    <div
      v-if="serviceNotes"
      v-lazy-container="{ selector: 'img' }"
      class="content"
      v-html="serviceNotes"
    />
  </div>
</template>

<script>
export default {
  props: {
    serviceMainUrl: {
      type: String
    }
  },
  asyncData ({ params }) {
    return {
      serviceId: params.service
    }
  },
  data () {
    return {
      serviceNotes: null
    }
  },
  head () {
    return {
      link: [
        { hid: 'canonical', rel: 'canonical', href: this.serviceMainUrl }
      ]
    }
  },
  computed: {
    service () {
      return this.$store.state.service.serviceData[parseInt(this.serviceId)]
    }
  },
  mounted () {
    this.replaceImageSrc()
  },
  methods: {
    replaceImageSrc () {
      this.serviceNotes = this.service.note.replace(/<img([^>]*)src=["']([^"']*)["']([^>]*)>/gi, (match, p1, p2, p3) =>
        `<img${p1}data-src="${p2}"${p3}>`
      )
    }
  }
}
</script>
